import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Deregister ("retire") a patient from CDM — CDM dataset Ref 71 "Retire a Patient"
// (KIN-1062 FE; BE endpoint per KIN-1034).
// PUT {tenant}/cdm/patients/{patientId}/deregister  body: { reason, otherReason }.
// otherReason (spec X0337-9, free text max 30 chars) is required by the spec only
// when reason === "OTHER"; it is null otherwise.
// Returns a DeregistrationResponse: { success, message, ... }. The endpoint
// answers 200 even when the HL7 messages were sent but NOT acknowledged — in
// that case success === false and the patient is unchanged, so we must treat it
// as a failure rather than relying on the HTTP status alone.
export const useDeregisterCDM = ({ patientId }) => {
  const queryClient = useQueryClient();

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    // Surface the real BE message in the dialog; skip the generic global toast.
    meta: { skipGlobalError: true },
    mutationFn: async ({ reason, otherReason = null }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.put(
        `${tenantVal}/cdm/patients/${patientId}/deregister`,
        { reason, otherReason }
      );

      if (response.data?.success === false) {
        throw new Error(
          response.data?.message ||
            "Deregistration was not acknowledged. Patient status unchanged."
        );
      }

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["patientCDMStatus", patientId],
      });
    },
  });
};
